<template>
    <div class="authorCenter" :style="ispopshow?'height:100vh;overflow:hidden':''">
        <Header></Header>
        <div class="authorBox flexible authorBox-big">
            <authorbar :navlist="navlist" :bookdetail="bookdetail"></authorbar>
            <div class="writewrap flex">
                <!-- <Bread></Bread> -->
                <router-view :bookdetail="bookdetail" @changePop="changePop" @changeChapter="getBookInfo"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from "vuex";
    // import { finishbook, getfinishbook, publishBook } from "apiurl/author";
    import {
        bookInfoApi
    } from "apiurl/author";
    export default {
        data() {
            return {
                navlist: [],
                bookdetail: {},
                bookId: '',
                ispopshow: false,
            };
        },
        created() {
            this.$nextTick(() => {
                this.getBookInfo();
            });
        },
        watch: {},
        methods: {
            // 获取作品信息
            getBookInfo() {
                bookInfoApi(this.$route.params.id).then(res => {
                    if (res.success) {
                        this.bookdetail = res.data;
                        if (!this.bookdetail.audit) {
                            this.navlist.push({
                                url: "/author/authorManage/contract/" + this.bookId,
                                name: "申请签约",
                                icon: require('@/assets/author/senLevel/ic_sqqy-def.png'),
                                icon1: require('@/assets/author/senLevel/ic_sqqy-select.png')
                            })
                        }
                    }
                });
            },
            changePop(data) {
                this.ispopshow = data
            }
        },
        mounted() {
            this.bookId = this.$route.params.id
            this.navlist = [{
                url: "/author/authorManage/chapterList/" + this.bookId,
                name: "章节列表",
                icon: require('@/assets/author/senLevel/ic_zjlb-def.png'),
                icon1: require('@/assets/author/senLevel/ic_zjlb-select.png')
            }]
        }
    };
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";
</style>